import UpdateSelfieForm from './UpdateSelfieForm';
import withModal from '../modal/withModal';

export const UPDATE_SELFIE_FORM_MODAL = 'modal/UPDATE_SELFIE_FORM_MODAL';

export default withModal(UpdateSelfieForm, {
  name: UPDATE_SELFIE_FORM_MODAL,
  size: 'md',
  type: 'full',
});
